export const getShelfLocationsFilter = (shelfLocations: string[] = []) => {
  return {
    ...(shelfLocations.length > 0 && {
      $or: [
        {
          'rxFillRequests.dispensed.ffsInventoryInfo.warehouseLocation': {
            $in: shelfLocations.map(shelfLocation => new RegExp(`^${shelfLocation}`)),
          },
        },
        {
          'otcProducts.dispensed.ffsInventoryInfo.warehouseLocation': {
            $in: shelfLocations.map(shelfLocation => new RegExp(`^${shelfLocation}`)),
          },
        },
      ],
    }),
  }
}

export default getShelfLocationsFilter
